<template>
    <app-layout v-if="isPageReady">
        <common-page-plain>
            <common-content-spacer height="medium">
                <common-page-header
                    :heading="$t('pages.referrals.new.steps.search.heading')"
                    :content="$t('pages.referrals.new.steps.search.description')"
                    :isCenter="true"
                ></common-page-header>
                <common-loader v-if="isLoading" :isProcessing="isLoading"></common-loader>
                <common-content-wrapper v-else width="small">
                    <referrals-new-search-form
                        :insurancePlans="insurancePlans"
                        :specialities="specialities"
                        :states="states"
                        :facilityServices="facilityServices"
                        @sent="showResults($event)"
                        @open-paywall-modal="openPaywallModal"
                    ></referrals-new-search-form>
                </common-content-wrapper>
            </common-content-spacer>
        </common-page-plain>
        <paywall-modal v-if="isPaywallModalOpen" @close="isPaywallModalOpen = false"></paywall-modal>
    </app-layout>
</template>

<script>
    import PageWithTitleMixin from 'mixins/PageWithTitleMixin'
    import PageWithElementsMixin from 'mixins/PageWithElementsMixin'
    import PageWithDataMixin from 'mixins/PageWithDataMixin'
    import ReferralsNewPageMixin from 'mixins/ReferralsNewPageMixin'
    import AppLayout from 'components/layouts/AppLayout'
    import ReferralsNewSearchForm from 'components/forms/ReferralsNewSearchForm'
    import InsurancePlanGroupsAPI from 'api/InsurancePlanGroupsAPI'
    import SpecialitiesAPI from 'api/SpecialitiesAPI'
    import StatesAPI from 'api/StatesAPI'
    import FacilityServicesAPI from 'api/FacilityServicesAPI'

    export default {
        mixins: [PageWithTitleMixin, PageWithElementsMixin, PageWithDataMixin, ReferralsNewPageMixin],

        components: {
            AppLayout,
            ReferralsNewSearchForm,
        },

        data() {
            return {
                insurancePlans: [],
                specialities: [],
                states: [],
                facilityServices: [],
                isPaywallModalOpen: false,
                isLoading: false,
            }
        },

        methods: {
            showResults(query) {
                this.$router.push({
                    name: 'pool.new.results',
                    query: query,
                    params: {
                        existingReferral: this.$route.params.existingReferral,
                    },
                })
            },

            openPaywallModal() {
                this.isPaywallModalOpen = true
            },

            getPageData() {
                this.isLoading = true
                Promise.all([
                    InsurancePlanGroupsAPI.getList(),
                    SpecialitiesAPI.getList(),
                    StatesAPI.getList(),
                    FacilityServicesAPI.getFacilityServiceGroupsTransform(),
                ])
                    .then(([insurancePlans, specialities, states, facilityServices]) => {
                        this.insurancePlans = insurancePlans
                        this.specialities = specialities
                        this.states = states
                        this.facilityServices = facilityServices
                    })
                    .finally(() => {
                        this.isLoading = false
                    })
            },
        },

        mounted() {
            this.getPageData()
        },
    }
</script>
